import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[sukaListItem]'
})
export class ListItemDirective {
  @HostBinding('class.list__item') wrapper = true;
}
